<template>
  <ul class="tab-menu">
    <li
      v-for="(tab, index) in tabs"
      v-show="displayTab[index][0]"
      v-bind:class="{ active: currentTab === index }"
      :key="'tab_' + index"
    >
      <button type="button" @click="changeTab(index, $event)">
        {{ tab }}
      </button>
    </li>
  </ul>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";

export default {
  props: ["currentTab"],
  data() {
    return {
      tabs: [this.$i18nUtil.trans("message.AuditTab.001","권한 관리"),this.$i18nUtil.trans("message.AuditTab.002","공간 관리"),this.$i18nUtil.trans("message.AuditTab.003","감사 기능"),this.$i18nUtil.trans("message.AuditTab.004","시스템 설정"),this.$i18nUtil.trans("message.AuditTab.005","통계관리"), this.$i18nUtil.trans("message.AuditTab.006","활동 현황")],
      tabFuncId: ["SYS_ROLE_MANAGE","SYS_GROUP_MANAGE","SYS_DLPL_VIEW","SYS_TDUL_MANAGE", "SYS_USST_VIEW", "SYS_STAT_USER"],
      displayTab: [
        [],[],[],[],[],[]
      ],
      roleTypeUser: false,
    };
  },
  created() {
    this.menuCheck();
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    /* 팀장 권한 확인
    checkRoleTypeUser() {
        let obj = this;
        let reqData = {};
        reqData.params = {
            roleType: "TLD",
        };
        reqData.url = "/api/org/checkRoleTypeUser";
        reqData.method = "post";            
        
        obj.COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function(res) {
            obj.roleTypeUser = res.result;
            if(obj.roleTypeUser){
              obj.checkRoleUserFnc("SYS_DLPL_VIEW");
            } else {
              obj.menuCheck();
            }
        })
        .catch(function(err) {
            console.log(err);
        });
    }, */
    menuCheck(){
      for(let index in this.tabFuncId){
        this.checkRoleUserFnc(this.tabFuncId[index]);
      }
    },
    checkRoleUserFnc(id){
      let obj = this;
      let reqData = {
        url : "/api/org/checkRoleUserFnc",
        method : "post",
        params : {
          funcId : id
        }
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        if (res != null) {
          switch (id) {
            case "SYS_ROLE_MANAGE":
              obj.displayTab[0].push(res.result);
              break;
            case "SYS_GROUP_MANAGE":
              obj.displayTab[1].push(res.result);
              break;
            case "SYS_DLPL_VIEW":
              obj.displayTab[2].push(res.result);
              break;
            case "SYS_TDUL_MANAGE":
              obj.displayTab[3].push(res.result);
              break;
            case "SYS_USST_VIEW":
              obj.displayTab[4].push(res.result);
              break;
            case "SYS_STAT_USER":
              obj.displayTab[5].push(res.result);
              break;
          }
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    changeTab(index, e) {
      if ($(e.target.parentElement).hasClass("active")) {
        return;
      }
      if (index == 0) {
        // 라우터 이동
        this.$router.replace("/cosys/getRoleList");
      } else if (index == 1) {
        this.$router.replace("/cosys/proAndPrivateList");
      } else if (index == 2) {
        this.$router.replace("/cosys/fileDlpBlock");
      } else if (index == 3) {
        this.$router.replace("/cosys/getTdulList");
      } else if (index == 4) {
        this.$router.replace("/cosys/statisticsManage");
      } else if (index == 5) {
        this.$router.replace("/cosys/MonitorUserStat");
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/AuditTab.vue